import { render, staticRenderFns } from "./AzPacientePropriedades.vue?vue&type=template&id=63e47be5&"
import script from "./AzPacientePropriedades.vue?vue&type=script&lang=js&"
export * from "./AzPacientePropriedades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports